import React from 'react';
import PropTypes from 'prop-types';
import FontIcon from 'material-ui/FontIcon';

import pallet from 'constants/colors';

const StatusIcon = ({ type }) => {
  const icon = {
    0: 'label_outline', 1: 'label_outline', 2: 'done', 3: 'lock_outline', 4: 'done_all', 5: 'priority_high',
  };
  const color = {
    0: pallet.errorColor, 1: pallet.warningColor, 2: pallet.successColor, 3: '#a1a1a1', 4: pallet.successColor, 5: pallet.errorColor,
  };
  if (type === -1 || type === 3) { return <div />; }
  return (
    <FontIcon
      color={color[type]}
      className="material-icons"
      style={{ marginRight: 8 }}
    >
      {icon[type]}
    </FontIcon>
  );
};


StatusIcon.propTypes = {
  type: PropTypes.oneOf([-1, 0, 1, 2, 3, 4, 5]).isRequired,
};

export default StatusIcon;



// WEBPACK FOOTER //
// ./src/components/StatusIcon.js